<template>
    <form @submit.prevent="submit()" enctype="multipart/form-data">
        <!-- Name Field -->
        <div :class="{ 'has-error': errors.name }" class="form-group col-sm-6">
            <label for="name">
                Nombre para el componente:
            </label>
            <input class="form-control" id="name" type="text" v-model="data.name">
                <div class="help-block" v-if="errors.name">
                    {{ errors.name }}
                </div>
        </div>
        <!-- Id Landing Pages Components Field -->
        <div :class="{ 'has-error': errors.id_landing_pages_components }" class="form-group col-sm-6">
            <label for="id_landing_pages_components">
                Seleccione un Componente:
            </label>
            <select @change="onChangeComponents()" class="form-control" id="id_landing_pages_components" v-model="data.id_landing_pages_components">
                <option v-bind:value="{ id: component.id, text: component.component }" v-for="(component, index ) in components" v-text="component.title" :key="index">
                </option>
            </select>
            <div class="help-block" v-if="errors.id_landing_pages_components">
                {{ errors.id_landing_pages_components }}
            </div>
        </div>
        <!-- Active Field -->
        <div class="form-group col-sm-12">
            <label for="active">
                Activo?:
            </label>
            <br/>
            <label>
                <input id="active" type="checkbox" v-model="data.active" value="1"></input>
            </label>
        </div>
        <!-- Componente Nro 1 -->
        <div id="componente_1" v-if="showComponent === 'svlp-component-2h-text-url-image-horario'">
            <div class="col-sm-12">
                <h4 class="panel-title">
                    Configuración para componente
                </h4>
                <img src="/images/landing-sucursal-virtual/Principal.png" alt="" style="width: 100%">
                <hr/>
            </div>
            <div class="form-group col-md-8">
                <label for="input_title_1">1. Ingrese el título</label>
                <input type="text" class="form-control" id="input_title_1" v-model="data.input_title_1">
                <div class="help-block" v-if="errors.input_title_1">
                    {{ errors.input_title_1 }}
                </div>
            </div>
            <div class="form-group col-md-8">
                <label for="input_subtitle_1">2. Ingrese el subtítulo</label>
                <textarea id="input_subtitle_1" class="form-control" rows="3" v-model="data.input_subtitle_1"></textarea>
                <div class="help-block" v-if="errors.input_subtitle_1">
                    {{ errors.input_subtitle_1 }}
                </div>
            </div>
            <div class="form-group col-md-8">
                <label for="input_subtitle_2">3. Ingrese el texto</label>
                <textarea id="input_subtitle_2" class="form-control" rows="3" v-model="data.input_subtitle_2"></textarea>
                <div class="help-block" v-if="errors.input_subtitle_2">
                    {{ errors.input_subtitle_2 }}
                </div>
            </div>
            <div class="form-group col-md-8">
                <label for="input_title_2">4. Ingrese el título del botón</label>
                <input type="text" class="form-control" id="input_title_2" v-model="data.input_title_2">
                <div class="help-block" v-if="errors.input_title_2">
                    {{ errors.input_title_2 }}
                </div>
            </div>
            <!-- input_image_1 Field -->
            <div :class="{'has-error': errors.input_image_1}" class="form-group col-md-8">
                <label for="input_image_1">
                    5. Seleccione una imagén:
                </label>
                <input class="form-control" id="input_image_1" type="file" v-on:change="onFileChange(1)" accept="image/png,image/jpeg">
                <div class="help-block" v-if="errors.input_image_1">
                    {{ errors.input_image_1 }}
                </div>
            </div>
            <br>
        </div>
        <!-- Componente Nro 2 -->
        <div id="componente_2" v-if="showComponent === 'svlp-component-card-ways'">
            <div class="col-sm-12">
                <h4 class="panel-title">
                    Configuración para componente
                </h4>
                <img src="/images/landing-sucursal-virtual/Cards.png" alt="" style="width: 100%">
                <hr/>
            </div>

            <div :class="{'has-error': errors.input_image_1}" class="form-group col-md-8 mt-5">
                <label for="input_image_1">
                    1. Imagen Nro 1:
                </label>
                <select @change="onChangeCardIcon(1)" class="form-control" id="id_landing_pages_components" v-model="data.input_image_1">
                    <option v-bind:value="cardIcon.image" v-for="(cardIcon, index ) in cardIcons" v-text="cardIcon.name" :key="index"></option>
                </select>
                <div class="help-block" v-if="errors.input_image_1">
                    {{ errors.input_image_1 }}
                </div>
            </div>
            <div :class="{'has-error': errors.input_title_1}" class="form-group col-md-8">
                <label for="input_title_1">2. Ingrese el título Nro 1</label>
                <input type="text" class="form-control" id="input_title_1" v-model="data.input_title_1">
                <div class="help-block" v-if="errors.input_title_1">
                    {{ errors.input_title_1 }}
                </div>
            </div>

            <div :class="{'has-error': errors.input_subtitle_1}" class="form-group col-md-8">
                <label for="input_subtitle_1">3. Ingrese la descripción</label>
                <textarea id="input_subtitle_1" class="form-control" rows="3" v-model="data.input_subtitle_1"></textarea>
                <div class="help-block" v-if="errors.input_subtitle_1">
                    {{ errors.input_subtitle_1 }}
                </div>
            </div>

            <div :class="{'has-error': errors.input_image_2}" class="form-group col-md-8 mt-5">
                <label for="input_image_2">
                    1. Imagen Nro 2:
                </label>
                <select @change="onChangeCardIcon(2)" class="form-control" id="id_landing_pages_components" v-model="data.input_image_2">
                    <option v-bind:value="cardIcon.image" v-for="(cardIcon, index ) in cardIcons" v-text="cardIcon.name" :key="index"></option>
                </select>
                <div class="help-block" v-if="errors.input_image_2">
                    {{ errors.input_image_2 }}
                </div>
            </div>
            <div :class="{'has-error': errors.input_title_2}" class="form-group col-md-8">
                <label for="input_title_2">2. Ingrese el título Nro 2</label>
                <input type="text" class="form-control" id="input_title_2" v-model="data.input_title_2">
                <div class="help-block" v-if="errors.input_title_2">
                    {{ errors.input_title_2 }}
                </div>
            </div>
            <div :class="{'has-error': errors.input_subtitle_2}" class="form-group col-md-8">
                <label for="input_subtitle_2">3. Ingrese la descripción</label>
                <textarea id="input_subtitle_2" class="form-control" rows="3" v-model="data.input_subtitle_2"></textarea>
                <div class="help-block" v-if="errors.input_subtitle_2">
                    {{ errors.input_subtitle_2 }}
                </div>
            </div>

            <div :class="{'has-error': errors.input_image_3}" class="form-group col-md-8 mt-5">
                <label for="input_image_3">
                    1. Imagen Nro 3:
                </label>
                <select @change="onChangeCardIcon(3)" class="form-control" id="id_landing_pages_components" v-model="data.input_image_3">
                    <option v-bind:value="cardIcon.image" v-for="(cardIcon, index ) in cardIcons" v-text="cardIcon.name" :key="index"></option>
                </select>
                <div class="help-block" v-if="errors.input_image_3">
                    {{ errors.input_image_3 }}
                </div>
            </div>
            <div :class="{'has-error': errors.input_title_3}" class="form-group col-md-8">
                <label for="input_title_3">2. Ingrese el título Nro 3</label>
                <input type="text" class="form-control" id="input_title_3" v-model="data.input_title_3">
                <div class="help-block" v-if="errors.input_title_3">
                    {{ errors.input_title_3 }}
                </div>
            </div>
            <div :class="{'has-error': errors.input_subtitle_3}" class="form-group col-md-8">
                <label for="input_subtitle_3">3. Ingrese la descripción</label>
                <textarea id="input_subtitle_3" class="form-control" rows="3" v-model="data.input_subtitle_3"></textarea>
                <div class="help-block" v-if="errors.input_subtitle_3">
                    {{ errors.input_subtitle_3 }}
                </div>
            </div>


        </div>
        <!-- Componente Nro 3 -->
        <div id="componente_3" v-if="showComponent === 'svlp-component-tramites-available'">
            <div class="col-sm-12">
                <h4 class="panel-title">
                    Configuración para componente
                </h4>
                <img v-if="showInformativo" src="/images/landing-sucursal-virtual/Informativo.png" alt="" style="width: 100%">
                <hr/>
            </div>
            <div class="form-group col-md-6" v-if="AddOneMoreElement">
                <a class='btn btn-default btn-xs' @click.prevent="AddOneMore(3)"><i class="fa fa-plus-circle"></i></a><span> Desea agregar un cuadro informativo?</span>
                <hr />
                <p style="text-align: justify;">Recuerde que los trámites serán agregados automaticamente al landing page, siempre y  cuando se encuentren disponibles</p>
            </div>

            <div v-if="showInformativo" class="form-group col-md-8">
                <div :class="{'has-error': errors.input_title_1}" class="form-group col-md-8">
                    <label for="input_title_1">1. Ingrese el título</label>
                    <input type="text" class="form-control" id="input_title_1" v-model="data.input_title_1">
                    <div class="help-block" v-if="errors.input_title_1">
                        {{ errors.input_title_1 }}
                    </div>
                </div>
                
                <div :class="{'has-error': errors.input_subtitle_1}" class="form-group col-md-8">
                    <label for="input_subtitle_1">2. Ingrese el texto</label>
                    <textarea id="input_subtitle_1" class="form-control" rows="3" v-model="data.input_subtitle_1"></textarea>
                    <div class="help-block" v-if="errors.input_subtitle_1">
                        {{ errors.input_subtitle_1 }}
                    </div>
                </div>
            </div>
        </div>
        <!-- Componente Nro 4 -->
        <div id="componente_4" v-if="showComponent == 'svlp-component-text-url'">
            <div class="col-sm-12">
                <h4 class="panel-title">
                    Configuración para componente
                </h4>
                <img src="/images/landing-sucursal-virtual/Contacto.png" alt="" style="width: 100%">
                <hr/>
            </div>
            <div class="form-group col-md-8" :class="{'has-error': errors.input_subtitle_1}">
                <label for="input_subtitle_1">1. Ingrese el texto</label>
                <div v-if="showEditor" :key="llave">
                    <editor-texto-banner v-model="data.input_subtitle_1"> </editor-texto-banner>
                </div>
                <div class="help-block" v-if="errors.input_subtitle_1">
                    {{ errors.input_subtitle_1 }}
                </div>
            </div>
        </div>

        <div class="form-group col-sm-12">
            <input :disabled="id_landing_pages_components === '' && data.name == null" class="btn btn-primary" type="submit" value="Guardar">
                <a class="btn btn-default" href="/backend/landing-page-components-data">
                    Cancelar
                </a>
            </input>
        </div>
    </form>    
</template>

<script>
import ElDatePicker from 'element-ui/lib/date-picker';
import EditorTextoBanner from "./EditorTextoBanner.vue"; 
export default {

    data() {
        return {
            errors: {},
            data: [],
            llave: 1,
            components: [],
            showComponent: false,
            showThirdSection: false,
            showForthSection: false,
            AddOneMoreElement: true,
            counter: 0,
            editSchedule: false,
            showInformativo: false,
            showEditor: false,
            cardIcons: [
                {
                    name: 'Seguro',
                    image: '/images/landing-sucursal-virtual/seguro.svg'
                },
                {
                    name: 'Desde cualquier lugar',
                    image: '/images/landing-sucursal-virtual/resolutivo.svg'
                },
                {
                    name: 'Facil',
                    image: '/images/landing-sucursal-virtual/facil.svg'
                },
            ]
        }
    },

    components:{
        ElDatePicker,EditorTextoBanner
    },
    mounted() {
        this.fetchComponents();
    },
    watch: {
        showComponent: function (value) {
            this.llave=this.llave++;
        }
    },

    methods: {
        fetchComponents: function() {
            self = this
            axios({
                url: 'backend/sucursal-virtual-components-data/getcomponents',
                method: 'GET',
            }).then(function(response){
                self.components = response.data.components;
            }).catch(function(error){
                console.log(error);
            });
        },
        onChangeCardIcons(caso){

            switch (caso) {
                case 1:
                    this.data.input_image_1 = event.target.value;   
                    break;
            
                case 2:
                    this.data.input_image_2 = event.target.value;   
                    break;
            
                case 3:
                    this.data.input_image_3 = event.target.value;   
                    break;
        
            }

            console.log(event.target.value)
        },
        onFileChange(caso){
            switch (caso) {
                case 1:
                    this.data.input_image_1 = event.target.files[0];
                    break;
                case 2:
                    this.data.input_image_2 = event.target.files[0];
                    break;
            
                case 3:
                    this.data.input_image_3 = event.target.files[0];
                    break;
            
            }
        },
        onChangeComponents: function () {

            this.showEditor = false
            this.showComponent          = this.data.id_landing_pages_components.text;
            this.AddOneMoreElement      = true
            this.counter                = 0
            this.showThirdSection       = false
            this.showForthSection       = false
            this.editSchedule           = false
            this.showInformativo        = false

            if (this.showComponent == 'svlp-component-text-url') {
                this.showEditor = true
            }

            // inputs
            this.data.input_title_1 = undefined;
            this.data.input_title_2 = undefined;
            this.data.input_title_3 = undefined;
            this.data.input_title_4 = undefined;
            this.data.input_subtitle_1 = undefined;
            this.data.input_subtitle_2 = undefined;
            this.data.input_subtitle_3 = undefined;
            this.data.input_image_1 = undefined;
            this.data.input_image_2 = undefined;
            this.data.input_image_3 = undefined;
            this.data.input_link_1 = undefined;
            this.data.input_link_2 = undefined;
            this.data.input_link_3 = undefined;
            this.data.input_link_4 = undefined;
            // errors
            this.errors.input_title_1 = false;
            this.errors.input_title_2 = false;
            this.errors.input_title_3 = false;
            this.errors.input_title_4 = false;
            this.errors.input_subtitle_1 = false;
            this.errors.input_subtitle_2 = false;
            this.errors.input_subtitle_3 = false;
            this.errors.input_image_1 = false;
            this.errors.input_image_2 = false;
            this.errors.input_image_3 = false;
            this.errors.input_link_1 = false;
            this.errors.input_link_2 = false;
            this.errors.input_link_3 = false;
            this.errors.input_link_4 = false;
        },
        AddOneMore(number) {
            
            switch (number) {
                case 1:
                    self.counter = self.counter + 1
                    if (self.counter == 1) {
                        self.showThirdSection = true                
                    }
                    if (self.counter == 2) {
                        self.showForthSection   = true
                        self.AddOneMoreElement  = false
                    }
                    break;
                case 2:
                    self.editSchedule       = true
                    self.AddOneMoreElement  = false
                    break;
                case 3:
                    self.showInformativo    = true
                    self.AddOneMoreElement  = false
                    break;
                default:
                    break;
            }
        },
        submit: function(){
            this.errors = {};
            // si campo nombre es vacío
            if(typeof(this.data.name) == undefined || this.data.name == '' || this.data.name == null) {
                this.errors.name = "El campo Nombre es requerido";
            } else {
                this.errors.name = false;
            }
            // si campo componente es vacío
            this.errors.id_landing_pages_components = null;
            if(typeof(this.data.id_landing_pages_components) == undefined || this.data.id_landing_pages_components == '' || this.data.id_landing_pages_components == null) {
                this.errors.id_landing_pages_components = "El campo Componente es requerido";
            } else {
                this.errors.id_landing_pages_components = false;
            }

            // Para componentes

            switch (this.showComponent) {
                case 'svlp-component-2h-text-url-image-horario':
                    // campo titulo 1
                    if(typeof(this.data.input_title_1) == undefined || this.data.input_title_1 == '' || this.data.input_title_1 == null) {
                        this.errors.input_title_1 = "El campo Título es requerido";
                    } else {
                        this.errors.input_title_1 = false;
                    }
                    // campo titulo 2
                    if(typeof(this.data.input_title_2) == undefined || this.data.input_title_2 == '' || this.data.input_title_2 == null) {
                        this.errors.input_title_2 = "El campo Título es requerido";
                    } else {
                        this.errors.input_title_2 = false;
                    }
                    // campo subtitulo 1
                    if(typeof(this.data.input_subtitle_1) == undefined || this.data.input_subtitle_1 == '' || this.data.input_subtitle_1 == null) {
                        this.errors.input_subtitle_1 = "El campo Título es requerido";
                    } else {
                        this.errors.input_subtitle_1 = false;
                    }
                    // campo imagen 1
                    if(typeof(this.data.input_image_1) == undefined || this.data.input_image_1 == '' || this.data.input_image_1 == null) {
                        this.errors.input_image_1 = "El campo Título es requerido";
                    } else {
                        this.errors.input_image_1 = false;
                    }

                    break;
                case 'svlp-component-card-ways':
                    // campo imagen 1
                    if(typeof(this.data.input_image_1) == undefined || this.data.input_image_1 == '' || this.data.input_image_1 == null) {
                        this.errors.input_image_1 = "El campo Imagen 1 es requerido";
                    } else {
                        this.errors.input_image_1 = false;
                    }
                    // campo imagen 2
                    if(typeof(this.data.input_image_2) == undefined || this.data.input_image_2 == '' || this.data.input_image_2 == null) {
                        this.errors.input_image_2 = "El campo Imagen 2 es requerido";
                    } else {
                        this.errors.input_image_2 = false;
                    }
                    // campo imagen 3
                    if(typeof(this.data.input_image_3) == undefined || this.data.input_image_3 == '' || this.data.input_image_3 == null) {
                        this.errors.input_image_3 = "El campo Imagen 3 es requerido";
                    } else {
                        this.errors.input_image_3 = false;
                    }
                    // campo titulo 1
                    if(typeof(this.data.input_title_1) == undefined || this.data.input_title_1 == '' || this.data.input_title_1 == null) {
                        this.errors.input_title_1 = "El campo Título es requerido";
                    } else {
                        this.errors.input_title_1 = false;
                    }
                    // campo titulo 2
                    if(typeof(this.data.input_title_2) == undefined || this.data.input_title_2 == '' || this.data.input_title_2 == null) {
                        this.errors.input_title_2 = "El campo Título es requerido";
                    } else {
                        this.errors.input_title_2 = false;
                    }
                    // campo titulo 3
                    if(typeof(this.data.input_title_3) == undefined || this.data.input_title_3 == '' || this.data.input_title_3 == null) {
                        this.errors.input_title_3 = "El campo Título es requerido";
                    } else {
                        this.errors.input_title_3 = false;
                    }
                    // campo subtitulo 1
                    if(typeof(this.data.input_subtitle_1) == undefined || this.data.input_subtitle_1 == '' || this.data.input_subtitle_1 == null) {
                        this.errors.input_subtitle_1 = "El campo Título es requerido";
                    } else {
                        this.errors.input_subtitle_1 = false;
                    }
                    // campo subtitulo 2
                    if(typeof(this.data.input_subtitle_2) == undefined || this.data.input_subtitle_2 == '' || this.data.input_subtitle_2 == null) {
                        this.errors.input_subtitle_2 = "El campo Título es requerido";
                    } else {
                        this.errors.input_subtitle_2 = false;
                    }
                    // campo subtitulo 3
                    if(typeof(this.data.input_subtitle_3) == undefined || this.data.input_subtitle_3 == '' || this.data.input_subtitle_3 == null) {
                        this.errors.input_subtitle_3 = "El campo Título es requerido";
                    } else {
                        this.errors.input_subtitle_3 = false;
                    }

                    break;
                case 'svlp-component-tramites-available':
                    // campo subtitulo 1
                    if(typeof(this.data.input_subtitle_1) == undefined || this.data.input_subtitle_1 == '' || this.data.input_subtitle_1 == null) {
                        this.errors.input_subtitle_1 = "El campo Título es requerido";
                    } else {
                        this.errors.input_subtitle_1 = false;
                    }

                    break;
                case 'svlp-component-text-url':
                    // campo subtitulo 1
                    if(typeof(this.data.input_subtitle_1) == undefined || this.data.input_subtitle_1 == '' || this.data.input_subtitle_1 == null) {
                        this.errors.input_subtitle_1 = "El campo Título es requerido";
                    } else {
                        this.errors.input_subtitle_1 = false;
                    }
                    
                    break;
            }

            let form_component = true;
            for (const error in this.errors) {
                if (this.errors[error] != false) {
                    form_component = false;
                    break;
                }
            }
            // Si formulario es válido
            if (!this.errors.name && !this.errors.id_landing_pages_components && form_component) {
                if (!this.data.active){
                    this.data.active = 0;
                }
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data',
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }

                let params = new FormData();
                params.append('name', this.data.name);
                params.append('id_landing_pages_components', this.data.id_landing_pages_components.id);
                params.append('active', this.data.active);
                params.append('input_title_1', this.data.input_title_1);
                params.append('input_title_2', this.data.input_title_2);
                params.append('input_title_3', this.data.input_title_3);
                params.append('input_title_4', this.data.input_title_4);
                params.append('input_subtitle_1', this.data.input_subtitle_1);
                params.append('input_subtitle_2', this.data.input_subtitle_2);
                params.append('input_subtitle_3', this.data.input_subtitle_3);
                params.append('input_image_1', this.data.input_image_1);
                params.append('input_image_2', this.data.input_image_2);
                params.append('input_image_3', this.data.input_image_3);
                params.append('input_link_1', this.data.input_link_1);
                params.append('input_link_2', this.data.input_link_2);
                params.append('input_link_3', this.data.input_link_3);
                params.append('input_link_4', this.data.input_link_4);
                
                
                axios.post('/backend/landing-page-components-data', params, config)
                    .then((response) => {
                        // console.log(response)
                        window.location.replace(response.data.redirect);
                    });
            }
        }
    }
}
</script>

<style scoped>
.mt-5 {
    margin-top: 1.5rem;
}
</style>